import {
  AbstractControl,
  UntypedFormControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export function wordValidation(nameRe: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const forbidden = control.value && !nameRe.test(control.value);
    return forbidden ? {forbiddenAphabet: true} : null;
  };
}

export function noWhitespaceValidator(
  control: UntypedFormControl | AbstractControl
) {
  const isSpace = (control.value || '').match(/\s/g);
  return isSpace ? {whitespace: true} : null;
}
